"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.home_heart = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var home_heart = function home_heart(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'home-heart-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.50922 1.43287C9.79098 1.18904 10.209 1.18904 10.4908 1.43287L17.4908 7.49057C17.6554 7.63303 17.75 7.83999 17.75 8.05769V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V8.05769C2.25 7.83999 2.3446 7.63303 2.50922 7.49057L9.50922 1.43287ZM3.75 8.4005V16.25H16.25V8.4005L10 2.99184L3.75 8.4005Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10 14L9.565 13.57C8.02 12.0414 7 11.0327 7 9.79836C7 8.78965 7.7245 8 8.65 8C9.172 8 9.673 8.26485 10 8.68174C10.327 8.26485 10.828 8 11.35 8C12.2755 8 13 8.78965 13 9.79836C13 11.0327 11.98 12.0414 10.435 13.57L10 14Z',
    fill: '#4B5563'
  }));
};

exports.home_heart = home_heart;